import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import React from 'react';
import { Eureka_CompleteInfo_Type, Eureka_EurekaSearchToken_Type, } from '../../services/generated/graphql-types';
import { SpotlightItemType } from './spotlight.types';
export const DEBOUNCE_DURATION = 200;
export const MAX_COMPLETIONS = 5;
export const COMPLETE_INFO = [
    {
        type: Eureka_CompleteInfo_Type.Query,
        requiredCompletions: MAX_COMPLETIONS,
    },
    {
        type: Eureka_CompleteInfo_Type.Object,
        requiredCompletions: MAX_COMPLETIONS,
    },
];
export var EurekaObjectType;
(function (EurekaObjectType) {
    EurekaObjectType["ANSWER"] = "ANSWER";
    EurekaObjectType["PINBOARD"] = "PINBOARD";
    EurekaObjectType["VISUALIZATION"] = "VISUALIZATION";
    EurekaObjectType["WORKSHEET"] = "WORKSHEET";
})(EurekaObjectType || (EurekaObjectType = {}));
export var EurekaQueryCompletionType;
(function (EurekaQueryCompletionType) {
    EurekaQueryCompletionType["RECENT"] = "RECENT";
    EurekaQueryCompletionType["POPULAR"] = "POPULAR";
})(EurekaQueryCompletionType || (EurekaQueryCompletionType = {}));
export const tokenizeQuery = (query) => {
    const trimmed = query.trim();
    if (!trimmed)
        return [];
    return trimmed.split(/\s+/).map(word => ({
        value: word,
        type: Eureka_EurekaSearchToken_Type.Unrecognized,
    }));
};
export const mapObjectCompletions = (results) => results
    .filter((r) => r?.type === 'OBJECT' && !!r?.objectResult?.guid)
    .map(r => ({
    guid: r.objectResult.guid,
    name: r.token?.value || r.objectResult.name,
    authorName: r.objectResult.authorName,
    type: r.objectResult.type,
    parentGuid: r.objectResult.parentGuid,
}));
export const buildObjectSearchItem = ({ isSearching, eurekaSearchPath, query, t, }) => {
    if (!isSearching || !eurekaSearchPath) {
        return null;
    }
    const trimmed = query.trim();
    const label = t('spotlight.completion.viewAllObjects', { query: trimmed });
    return {
        id: 'object-search',
        label,
        labelNode: (React.createElement(React.Fragment, null,
            t('spotlight.completion.viewAllObjects', { query: '' }),
            React.createElement("strong", null, trimmed))),
        icon: IconID.MAGNIFYING_GLASS,
        type: SpotlightItemType.OBJECT_SEARCH,
        path: `${eurekaSearchPath}?query=${encodeURIComponent(trimmed)}`,
    };
};
export const buildSpotterSuggestionItem = ({ isSearching, spotterPath, query, t, }) => {
    if (!isSearching || !spotterPath) {
        return null;
    }
    const trimmed = query.trim();
    const label = t('spotlight.completion.openInSpotter', { query: trimmed });
    return {
        id: `spotter-${trimmed}`,
        label,
        labelNode: (React.createElement(React.Fragment, null,
            t('spotlight.completion.openInSpotter', { query: '' }),
            React.createElement("strong", null, trimmed))),
        icon: IconID.SPOTTER,
        type: SpotlightItemType.SPOTTER_SUGGESTION,
        path: `${spotterPath}?query=${encodeURIComponent(trimmed)}`,
    };
};
export const mapQueryCompletions = (queryResults) => queryResults
    .filter((q) => !!q?.query)
    .map(q => ({
    query: q.query,
    type: q.type,
}));
//# sourceMappingURL=spotlight-completions.util.js.map